import React, { memo, useEffect } from 'react'
import {
  Typography, Box, FormControlLabel, Checkbox, Grid,
} from '@mui/material'
import stylesheet from '../detail/detail-container.stylesheet'
import { checkCondition } from '../detail/common/condition-check'
import { ClassNameMap, withStyles } from '@mui/styles'

interface IProps {
  input: any
  filterCount: any
  optionChanged: any
  classes: ClassNameMap
}

const FilterProgramChunkComponent: React.FC<IProps> = ({
  input,
  filterCount,
  optionChanged,
  classes
}) => {

  useEffect(() => {
    renderFilterList()
  }, [input])

  const renderFilterList = () => {
    return input?.map((e: any, i: number) => {
      return <Grid key={i} container direction="row" justifyContent="space-between" alignItems="center" className={classes.filterChunkItems}>
        <Grid item xs={10}>
          <FormControlLabel
            control={
              <Checkbox
                color="default"
                onChange={(event) => optionChanged(e.name, e.display_name, e.index, event.target.checked)}
                sx={{
                  transform: "scale(0.6) !important",
                  height: '0.6rem !important',
                  padding: '0px 0px 0px 5px !important',
                  color: e.color || 'default',
                }}
                className={classes.checkBoxStyle}
                checked={e.checked}
                name="checkedA"
                size="small"
              />
            }
            label={
              <Typography className={classes.desc} variant="body2">
                {checkCondition(e.checked === true, (<strong>{e.display_name}</strong>), e.display_name)}
              </Typography>
            }
          />
        </Grid>
        <Grid xs={2} item className={classes.whiteSpaceNowrap}>
          <Typography align='right' className={classes.desc} variant="body2" color="textSecondary">
            <small>{(e?.count || filterCount?.[e.value] || filterCount?.[e.name]) ?? '0'}</small>
          </Typography>
        </Grid>
      </Grid>
    })
  }

  return <Box pb={0.1}>
    {renderFilterList()}
  </Box>
}

export default memo(withStyles(stylesheet)(FilterProgramChunkComponent))
